export default function IconDelivering({color = "white", size = 24}) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M15 5.25L9 2.25L3 5.25M15 5.25L9 8.25M15 5.25V12.75L9 15.75M9 8.25L3 5.25M9 8.25V15.75M3 5.25V12.75L9 15.75"
                stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
        </svg>
    )
}
